// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3Dn9I","info":"PatientInfo_info__28D6S"};